import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getLawReport,
  getTableColumnNames,
  getLegalRank,
  getLawStatus,
  getArticleStatus,
  getInstrumentType,
  updateJsonStatus as putJsonStatus
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Law Report Table Column Names
export const fetchLawReportTableColumnNames = createAsyncThunk(
  "lawReport/fetchLawReportTableColumnNames",
  async (lawReport, thunkAPI) => {
    try {
      const response = await getTableColumnNames(lawReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch Law Report
export const fetchLawReport = createAsyncThunk(
  "lawReport/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getLawReport();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching human categories");
    }
  }
);

export const fetchLawStatus = createAsyncThunk(
  "lawReport/fetchLawStatus",
  async (lawReport, { rejectWithValue }) => {
    try {
      const response = await getLawStatus(lawReport);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching human categories");
    }
  }
);

export const fetchArticleStatus = createAsyncThunk(
  "lawReport/fetchArticleStatus",
  async (lawReport, { rejectWithValue }) => {
    try {
      const response = await getArticleStatus(lawReport);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching human categories");
    }
  }
);

export const fetchInstrumentType = createAsyncThunk(
  "lawReport/fetchInstrumentType",
  async (lawReport, { rejectWithValue }) => {
    try {
      const response = await getInstrumentType(lawReport);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching human categories");
    }
  }
);

export const updateJsonStatus = createAsyncThunk(
  "lawReport/updateJsonStatus",
  async (lawReport, { rejectWithValue }) => {
    try {
      const response = await putJsonStatus(lawReport);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching human categories");
    }
  }
);